import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M6.07 7.67a.467.467 0 0 1 .66 0l4 4a.467.467 0 1 1-.66.66l-4-4a.467.467 0 0 1 0-.66",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.73 7.67a.467.467 0 0 1 0 .66l-4 4a.467.467 0 0 1-.66-.66l4-4a.467.467 0 0 1 .66 0M4.424 7.624a.6.6 0 0 0 0-.848L1.648 4l2.776-2.776a.6.6 0 1 0-.848-.848l-3.2 3.2a.6.6 0 0 0 0 .848l3.2 3.2a.6.6 0 0 0 .848 0",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.2 9.4a.6.6 0 0 0 .6-.6V7.2A3.8 3.8 0 0 0 12 3.4H.8a.6.6 0 1 0 0 1.2H12a2.6 2.6 0 0 1 2.6 2.6v1.6a.6.6 0 0 0 .6.6M4 14.6A2.6 2.6 0 0 1 1.4 12v-1.6a.6.6 0 0 0-1.2 0V12A3.8 3.8 0 0 0 4 15.8h3.2a.6.6 0 1 0 0-1.2z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M12 14.6a2.6 2.6 0 0 0 2.6-2.6V8.8a.6.6 0 1 1 1.2 0V12a3.8 3.8 0 0 1-3.8 3.8H7.2a.6.6 0 1 1 0-1.2z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })